import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

const CommunityWeb = lazyLoad(() => import('.'));

// routes declaration
export const communityRoutes = [
  {
    component: Navigate,
    path: '/community',

    replace: true,
    to: '/community/all',
    needsAuth: true,
  },
  {
    component: CommunityWeb,
    path: '/community/:filterKey',
    title: 'Community',

    needsAuth: true,
  },
];
